module.exports = __webpack_public_path__ + "static/media/Calibre-SemiboldItalic.71941c0c.ttf";